/**
 * @module Workspaces
 * Container Component Workspaces
 */

import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import {EYForm, FormComboBox} from '@ey/form';
import {labels} from '../../../../util/uiconstants';
import {getSubServiceLineOptions} from '../../../../util/utils';
import Ellipse from '@ey/canvascoreservices/Ellipse';

const SubServiceLineList = (props) => {
	const {isDisabled, onChange, subserviceline, subservicelineOption} = props;

	const subServiceLinesOptions = getSubServiceLineOptions(
		subservicelineOption,
		subserviceline
	);

	const onSubServiceLineChange = (key, value) => {
		onChange(key, value);
	};

	return (
		<SubServiceLineContainer>
			<section>
				<EYForm
					id="subservicelineform"
					onChange={onSubServiceLineChange}
					onSubmit={() => {}}
					action="\"
				>
					<FormComboBox
						id="subserviceline"
						name="subserviceline"
						value={subserviceline}
						is_required
						help
						disabled={isDisabled}
						placeholder={labels.subserviceline}
						options={
							subServiceLinesOptions &&
							subServiceLinesOptions.map((subserviceline) => {
								return {
									value: String(subserviceline.subservicelineid),
									label: (
										<Ellipse
											content={subserviceline.subservicelinename}
											tooltip={subserviceline.subservicelinename}
											noOfLines={1}
										/>
									)
								};
							})
						}
						errormessage={labels.subservicelinerequired}
					/>
				</EYForm>
			</section>
		</SubServiceLineContainer>
	);
};

export default SubServiceLineList;

const SubServiceLineContainer = styled.li`
	display: inline-flex;
	margin: 0;
`;
